import { useCallback, useEffect, useState } from 'react';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import CreateIcon from '@mui/icons-material/Create';
import { useStyles } from '../book.style';
import { GetBooks, DeleteBook, PublishBook } from "../../../DAL/Books/books";
import { GetLanguage } from "../../../DAL/Language/language";
import { enqueueSnackbar } from "notistack";

export const useBook = () => {
  const classes = useStyles();
  const [BookData, setBookData] = useState([]);
  const [languageData, setlanguageData] = useState([]);
  const [BookCount, setBookCount] = useState(0);
  const [singleBook, setsingleBook] = useState('');
  const [open, setOpen] = useState(false);
  const [orderModal, setOrderModal] = useState(false);
  const [action, setAction] = useState('');
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [search, setSearch] = useState('');
  const [isLoading, setIsLoading] = useState(false)
  const [searchKey, setSearchKey] = useState("author")
  
  const tableCells = [
    { id: 'coverImage', title: 'Cover Image' },
    { id: 'author', title: 'Author Name' },
    { id: 'bookName', title: 'Book Name' },
    { id: 'bookNo', title: 'Book No' },
    { id: 'languageId', title: 'Language' },
    { id: 'isActive', title: 'Status' },
    { id: 'actions', title: 'Action(s)' },
  ];
  const actionsIcons = [
    { icon: <DeleteOutlineOutlinedIcon className={classes.iconStyle} />, action: "delete" },
    { icon: <CreateIcon className={classes.iconStyle} />, action: "edit" },
  ];

  useEffect(() => {
    getBooksData(page, limit, search, searchKey);
  }, [page, limit, search]);

  useEffect(() => {
    getLanguagesData()
  }, [])

  const getLanguagesData = useCallback(async() => {
      let data = false;
      const response = await GetLanguage(data);
          if (response.statusCode == 200) {
            const languageRes = response?.data?.rows?.map(item => ({
              value: item.id,
              text: item.name
            }));
            setlanguageData(languageRes);
          } else {
            setIsLoading(false);
            if (typeof response.message == "string") {
              enqueueSnackbar(response.message, { variant: "error" });
            } else {
              enqueueSnackbar("Invalid credentials", { variant: "error" });
            }
          }
    }, []);

  const getBooksData = useCallback(async(page, limit, search, searchKey) => {
    setIsLoading(true)
    let data = {
      page: Math.max(page + 1, 1),
      limit: limit,
      value: search,
      key: searchKey,
    }
    const response = await GetBooks(data);
        if (response.statusCode == 200) {
          setIsLoading(false);
          setBookData(response?.data?.rows);
          setBookCount(response?.data?.count);
    
        } else {
          setIsLoading(false);
          if (typeof response.message == "string") {
            enqueueSnackbar(response.message, { variant: "error" });
          } else {
            enqueueSnackbar("Invalid credentials", { variant: "error" });
          }
        }
  }, []);

  const handleDelete = useCallback(async(id) => {
    const response = await DeleteBook(id); 
        if (response.statusCode == 200) {
          getBooksData(page, limit, search)
        } else {
          if (typeof response.message == "string") {
            enqueueSnackbar(response.message, { variant: "error" });
          } else {
            enqueueSnackbar("Invalid credentials", { variant: "error" });
          }
        }
  }, []);

  const handlePublish = useCallback(async(id, status) => {
    const response = await PublishBook(id, status); 
        if (response.statusCode == 200) {
          getBooksData(page, limit, search)
          enqueueSnackbar(`Book ${status ? 'published' : 'unpublished'} successfully!`, { variant: "success" });
        } else {
          if (typeof response.message == "string") {
            enqueueSnackbar(response.message, { variant: "error" });
          } else {
            enqueueSnackbar("Invalid credentials", { variant: "error" });
          }
        }
  }, []);

  const handleAdd = useCallback(() => {
    setAction('add');
    setOpen(true);
  }, []);

  const handleActionClick = useCallback((index, row) => {
    setsingleBook(row);
    // dispatch(getsingleBookOrderData(row));
    if (index === 0) {
      setAction('delete');
      handleDelete(row.id);
    }
    if (index === 1) {
      setAction('update');
      setOpen(true);
    }
  }, []);

  const handleChangePage = useCallback((isTrue, newPage) => {
    if (isTrue) {
      setPage(newPage - 1);
    } else {
      setPage(newPage);
    }
  }, []);

  const handleChangeRowsPerPage = useCallback(event => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  }, []);

  const calculatePagesCount = (pageSize, totalCount) => {
    return totalCount < pageSize ? 1 : Math.ceil(totalCount / pageSize);
  };

  const handleBookSearch = useCallback(value => {
    setSearch(value);
    setPage(0);
    setLimit(10);
  }, []);

  const handleDropDown = useCallback(value => {
    setSearchKey(value);
    if(search) {
    getBooksData(0, 10, search, value);
    }
  }, []);

  const handleGetBookData = useCallback(value => {
    getBooksData(page, limit, search, searchKey)
  }, []);

  

  return {
    BookData,
    languageData,
    BookCount,
    singleBook,
    open,
    orderModal,
    action,
    tableCells,
    actionsIcons,
    page,
    limit,
    isLoading,
    searchKey,
    setOpen,
    setOrderModal,
    handleGetBookData,
    handleAdd,
    handleActionClick,
    handleChangePage,
    calculatePagesCount,
    handleChangeRowsPerPage,
    handleBookSearch,
    handleDropDown,
    handlePublish,
  };
};
